import { GET_ACTIVE_CAMPAIGNS, REST_EMAIL_API_URL, STRIPE_API_URL } from "./apiUrls";

export const toGetActiveCampaigns = () => {
  const Httpreq = new XMLHttpRequest();
  Httpreq.open("GET", GET_ACTIVE_CAMPAIGNS, false);
  Httpreq.send(null);
  return JSON.parse(Httpreq.responseText);
};

export const toCreatePaymentIntent = async (requestBody: object) => {
  const endPoint = "/create-payment-intent";
  return await fetch(STRIPE_API_URL + endPoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(requestBody),
  });
};

export const toUpdatePaymentIntent = async (requestBody: object, paymentIntentId: string) => {
  const endPoint = `/update-payment-intent/${paymentIntentId}`;
  return await fetch(STRIPE_API_URL + endPoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(requestBody),
  });
};

export const toUploadFormAdTypeData = async (requestBody: object, campaignId: number | string) => {
  const endPoint = `/formData?campaign_id=${campaignId}`;
  return await fetch(REST_EMAIL_API_URL + endPoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(requestBody),
  });
};
